<template>
  <div class="topForm upload">
    <vxe-toolbar size="mini" v-show="show">
      <template v-slot:buttons>
        <div v-if="printShow">
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-primary"
            icon="el-icon-download"
            @click="print(1)"
            >打印</vxe-button
          >
          <vxe-button
            size="medium"
            type="primary"
            class="vxe-btn-primary"
            icon="el-icon-download"
            @click="print(2)"
            >下载</vxe-button
          >
        </div>
        <div v-else>
          <vxe-button
            v-if="show"
            size="medium"
            type="primary"
            class="vxe-btn-delete"
            icon="el-icon-delete"
            @click="removeSelected()"
            >{{ $t('upload.delBtn') }}</vxe-button
          >
          <vxe-button
            v-if="show"
            size="medium"
            type="primary"
            class="vxe-btn-primary"
            icon="el-icon-download"
            @click="downLoadSelected()"
            >{{ $t('upload.downLoadBtn') }}</vxe-button
          >
          <div class="uploadBtn" v-if="show">
            <el-upload
              class="upload-demo"
              :action="actionUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :data="{ access_token: userInfo.userInfo.access_token, path: filePath }"
              multiple
              :on-exceed="handleExceed"
              :on-success="handleSuccess"
            >
              <vxe-button size="medium" type="primary" class="vxe-btn-save" icon="el-icon-upload">{{
                $t('upload.uploadBtn')
              }}</vxe-button>
              <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            </el-upload>
          </div>
        </div>
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      show-overflow
      resizable
      ref="xGrid"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :toolbar="tableToolbar"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
      @cell-dblclick="handleDblclick"
      @radio-change="handleRadioChange"
    >
      <!-- <vxe-table-column v-if="printShow" type="radio" width="50" fixed="left"></vxe-table-column>
      <vxe-table-column v-else type="checkbox" width="50" fixed="left"></vxe-table-column> -->
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <!--<vxe-table-column type="checkbox" width="50" fixed="left"></vxe-table-column>-->
      <vxe-table-column
        v-for="(item, index) in printShow ? columnListPrint : columnList"
        :key="index"
        :fixed="item.fixed"
        :sortable="item.sortable"
        :field="item.prop"
        :title="item.label"
      >
        <template v-slot="{ row }">
          <el-link v-if="item.prop == 'attachmentName'" type="primary" @click="handleclick(row)">
            {{ row.attachmentName }}</el-link
          >
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <Print ref="easyPrint">
      <print-demo :content="content"></print-demo>
    </Print>
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/dataBase';
  import { dateFormat } from '@/filters/index';
  import Print from '@/components/Print';
  // import API_TDO from '@/api/logisticsCenter/transportDeliveryOrder.js';
  import printDemo from '@/components/Print/printDemo';
  import baseUrl from '@/common/config';
  export default {
    name: 'upload',
    props: {
      //是否显示上传和删除按钮
      isShow: {
        type: Boolean,
        default: () => true,
      },
      //默认值
      tableData: {
        type: Array,
        default: () => [],
      },
      defaultPath: {
        type: String,
        default: 'scm/maindata',
      },
      //显示打印
      printShow: {
        type: Boolean,
        default: () => false,
      },
    },
    components: {
      Print,
      printDemo,
    },
    data() {
      let newDate = dateFormat(new Date());
      return {
        uploadTableData: this.tableData,
        multipleSelection: [], //存放选中的值
        todayDate: newDate,
        actionUrl: '',
        show: this.isShow,
        filePath: this.defaultPath,
        content: '',
        tableToolbar: {
          id: 'toolbar',
          // refresh: true,
          // setting: {
          //   storage: true
          // }
        },
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),

      //表格显示字段
      columnList() {
        return [
          {
            prop: 'attachmentName',
            label: this.$t('upload.printingName'),
            sortable: true,
          },
          // { prop: "createBy", label: this.$t("upload.uploader") },
          { prop: 'createTime', label: this.$t('upload.printingData') },
          { prop: 'sortNo', label: this.$t('upload.printingSortNo') },
        ];
      },
      columnListPrint() {
        return [
          {
            prop: 'attachmentName',
            label: this.$t('upload.attachmentName'),
            sortable: true,
          },
        ];
      },
    },
    mounted() {
      this.actionUrl = baseUrl + API.OSS_UPLOAD_API;
    },
    methods: {
      //返回数据
      getVal() {
        return JSON.stringify(this.tableData);
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      handleExceed(files, fileList) {
        this.$message.warning(
          `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
            files.length + fileList.length
          } 个文件`
        );
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${file.name}？`);
      },
      //上传成功
      handleSuccess(res, file) {
        if (res.code === 0) {
          let obj = {
            attachmentName: file.name,
            createBy: this.userInfo.userInfo.userName,
            gmtCreate: this.todayDate,
            attachmentPath: res.data.attachmentPath,
            attachmentKey: res.data.attachmentKey,
          };
          this.uploadTableData.push(obj);
          this.$refs.xGrid.reloadData(this.uploadTableData);
          this.$emit('upload', this.uploadTableData);
          //console.log(file,test)
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
      },
      //checkbox选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row.selection;
      },
      //radio表格选中事件
      handleRadioChange(val) {
        // this.$emit("handleSelectionChange", [val.row]);
        this.multipleSelection = [val.row];
      },
      //删除
      removeSelected() {
        let _self = this;
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDel'),
            type: 'error',
          });
        } else {
          this.$confirmAction()
            .then(() => {
              this.$refs['xGrid'].removeSelecteds();
              this.uploadTableData = this.uploadTableData.filter((item) => {
                let flag = true;
                this.multipleSelection.map((select) => {
                  if (item._XID == select._XID) {
                    flag = false;
                  }
                });
                return flag;
              });
              //如果操作成功，直接返回列表
              this.$message({
                type: 'success',
                message: this.$t('message.success'),
              });
              _self.$emit('upload', this.uploadTableData);
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      //批量下载
      downLoadSelected() {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message: this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          let params = {
            keyList: this.multipleSelection.map((it) => it.attachmentKey),
          };
          this.$axios.post(API.DOWNLOAD_FILE, params).then((res) => {
            if (res.data.code == 0) {
              res.data.data.map((it) => {
                this.downloadFile(it);
              });
            }
          });
        }
      },
      //多个文件下载
      downloadFile(url) {
        window.open(url, '_blank');
      },
      //单击预览
      handleclick(row) {
        var isChrome = navigator.userAgent.indexOf('Chrome') > -1; // 是否是谷歌
        if (isChrome) {
          window.location.href = row.attachmentPath;
        } else {
          window.open(row.attachmentPath, '_blank'); //url为生成PDF的url
        }
        this.$emit('upDataNo', row);
      },
      //双击下载文档
      handleDblclick(data) {
        window.location.href = data.row.attachmentPath;
        this.$emit('upDataNo', data.row);
      },
      //打印
      print(type) {
        if (this.multipleSelection.length === 0) {
          this.$message({
            showClose: true,
            message:
              type == 1 ? this.$t('upload.noSelectPrint') : this.$t('upload.noSelectDownLoad'),
            type: 'error',
          });
        } else {
          this.$emit('uploadPrint', this.multipleSelection[0], type);
        }
      },
    },
    watch: {
      tableData() {
        this.uploadTableData = this.tableData;
      },
      isShow() {
        this.show = this.isShow;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .uploadBtn {
    float: left;
    padding-right: 16px;
  }
</style>
